<template>
	<div class="window">
		<div class="overlay-area">
			<div class="overlay-indicator">
				<ui-load-indicator
					v-if="loading"
					bgColor="#e7e9f4"
					color="#69D296"
					:h="50"
					:stroke="8"
				></ui-load-indicator>
				<span v-else class="load-icon">
					<i v-if="success" class="fal fa-check-circle"></i>
					<i v-else class="fal fa-times error"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	export default {
		name: 'ui-load-success',

		components: {
			uiLoadIndicator
		},

		props: {
			loading: {
				type: Boolean,
				default: true
			},

			success: {
				type: Boolean,
				default: true
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
